import "material-icons/iconfont/material-icons.css";
import "./styles/main.scss";
import { render } from "preact";
import { App } from "./app";
import "./firebaseSetup";

const root = document.getElementById("content");
if (root) render(<App />, root);
